import React, { Component } from "react";

import {
  CButton,
  CCol,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow
} from "@coreui/react";
import { createPortal } from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { firstEmotionsDone } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";

import "./style.css";

const appRoot = document.getElementById("root");
const defaultMobileWidth = 985;

class EmotionsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 0,
      show: false,
      isMobile: false,
      emotions: []
      // emotionsWithId: []
    };

    this.el = document.createElement("div");
    this.windowSizeHandler = this.windowSizeHandler.bind(this);
  }

  windowSizeHandler() {
    /*
     Método para lidar com a resolução de tela
    */
    // Interpreta resoluções <=980px como mobile.
    // O valor padrão de resolução mínima fica na constante defaultMobileWidth
    window.innerWidth <= defaultMobileWidth
      ? this.setState({ isMobile: true })
      : this.setState({ isMobile: false });
  }

  componentDidMount() {
    // Faz a primeira validação se a resolução é
    // ou não <= mínimo.
    this.windowSizeHandler();
    appRoot.appendChild(this.el);
    // Caso exista mudança no tamanho da tela, chama o windowSizeHandler
    window.addEventListener("resize", this.windowSizeHandler);
    axios
      .get(`${URL.api}access/emotion/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success && resp.data.data) {
          const data = [...resp.data.data];
          let emotions = data;
          this.setState({
            emotions,
            show: true
          });
        } else {
          // O card não vai abrir: libera quem espera por ele (ver `fechar`).
          this.props.onClose?.();
        }
      })
      .catch(() => this.props.onClose?.());
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  onEmotion(emotion) {
    axios.post(
      `${URL.api}access/user_emotion/insert`,
      {
        user_id: this.props.user.user.id,
        emotion: emotion.name,
        emotion_id: emotion.id
      },
      { headers: { authorization: `Bearer ${this.props.user.token}` } }
    );
    this.fechar();
    this.props.firstEmotionsDone();
  }

  // `onClose` avisa o layout/Main.js, que segura o aviso de formulários
  // pendentes até o card sair da tela.
  fechar = () => {
    this.setState({ show: false });
    this.props.onClose?.();
  };

  render() {
    return createPortal(
      <CModal show={this.state.show} onClose={this.fechar} centered size="lg">
        <CModalHeader closeButton>
          <CModalTitle className="text-primary font-weight-bold h3 m-0">
            Como você está se sentindo hoje?
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 emotions-modal-body">
          <CRow>
            {this.state.emotions.map((emotion, index) => (
              <CCol
                key={index}
                className="emotions-items"
                // Varia o número de colunas conforme dispositivo/resolução
                xs={this.state.isMobile ? "4" : "3"}
              >
                <div
                  className={`emotions-modal-circle rounded-circle cursor${
                    this.state.selected === index ? " selected" : ""
                  }`}
                  onClick={() => this.setState({ selected: index })}
                >
                  <img
                    src={URL.img + emotion.url}
                    className="rounded-circle w-100 h-100"
                    style={{ border: "6px solid transparent" }}
                  />
                </div>
                <p className="emotion-name">{emotion.name}</p>
              </CCol>
            ))}
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            size="lg"
            className="mr-2"
            onClick={() =>
              this.onEmotion(this.state.emotions[this.state.selected])
            }
          >
            Responder
          </CButton>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ firstEmotionsDone }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmotionsModal);
